<template>
	<div
		id="pop_product"
		class="pop_product popup_wrap product_item product_item_data"
		style="display: block"
		v-bind:data-product-id="product.id"
	>
		<div class="popup_in" id="popupInPageSet">
			<div class="popup">
				<div class="popup_close close-animate">
					<a href="javascript:void(0);" @click.prevent="closePop()">
						<CLOSE />
					</a>
				</div>
				<div class="pp_prod_top">
					<div class="row clearfix">
						<div class="right pp_prod_img col-sm-5 col-xs-12">
							<div class="slide_img_wrap">
								<div class="arrow_r ease" v-if="hasGallery">
									<a href="javascript:void(0);" @click.prevent="thumbNext">
										<arrow_r />
									</a>
								</div>
								<div class="arrow_l ease" v-if="hasGallery">
									<a href="javascript:void(0);" @click.prevent="thumbPrev">
										<arrow_l />
									</a>
								</div>
								<div class="slide_img">
									<slick
										ref="thumb"
										@init="handleInit"
										:options="slickThumbOptions"
										v-if="product.image"
									>
										<div class="product_img product_img_zoom">
											<img
												v-bind:src="product.imagebig"
												v-bind:data-magnify-src="product.imagebig"
											/>
										</div>
										<div
											class="product_img product_img_zoom"
											v-for="(image, index) in product.gallery"
											:key="image"
										>
											<img v-bind:src="image" v-bind:data-magnify-src="image" />
										</div>
									</slick>
								</div>
                <div v-if="isAdmin"><a :href="product.imagebig" download>הורדת תמונה</a></div>
							</div>
							<div class="flex pod_icon_wrap">
								<div class="pod_icon no-gluten" v-if="product.tags.indexOf(18) !== -1">ללא גלוטן</div>
								<div class="pod_icon organic" v-if="product.tags.indexOf(19) !== -1">אורגני</div>
								<div class="pod_icon vegan" v-if="product.tags.indexOf(365) !== -1">טבעוני</div>
								<div class="pod_icon frozen" v-if="product.tags.indexOf(1904) !== -1">
									קפוא <snow />
								</div>
                <div class="pod_icon israeli" v-if="product.tags && product.tags.indexOf(2937) !== -1">תוצרת<br>ישראל</div>
							</div>
							<div class="glass ease">
								<a href="javascript:void(0);" onclick>
									<glass />
								</a>
							</div>
						</div>
						<div class="left pp_prod_main col-sm-6 col-xs-12">
							<h2 class="title25" v-html="product.name"></h2>
              <div class="new-product" v-if="product.is_new">
                <new_svg/>
              </div>
							<div class="sub_amount" v-if="!product.hide_weight && product.weight">{{ weightText }}</div>
							<div class="pr_row_price">
								<div class="clearfix">
									<div
										class="right pr_price"
										v-bind:class="{ price_sale: product.onsale && product.oldprice }"
									>
										{{ product.price | currency("") }}
										<span class="currency">{{ currencySymbol }}</span>
									</div>
									<div class="right pr_price_kilo">
										/ {{ product.after_price_text ? product.after_price_text : unitPriceText }}
									</div>
									<div class="right pr_price_old" v-if="product.oldprice">
										{{ product.oldprice | currency("") }}
										<span class="currency">{{ currencySymbol }}</span>
									</div>
								</div>
							</div>
							<div class="pr_title_sale" v-if="sale && sale.bannertext">{{ sale.bannertext }}</div>
              <div class="pr_title_note sale-subtitle" v-if="sale && sale.limit && sale.date_end">
                מוגבל ל-{{ sale.limit }} מימושים. בתוקף עד {{ sale.date_end }}
              </div>
              <div class="pr_title_note sale-subtitle" v-if="sale && sale.banner_subtitle">
                {{ sale.banner_subtitle }}
              </div>
							<div class="pr_title_note" v-if="product.hide_weight != '1' && product.weight && pricePer100(product)">
                {{ pricePer100Text(product) }}
							</div>
							<div class="nutrition-tags" v-if="product.nutrition_tags">
								<div v-for="tag in product.nutrition_tags">
									<img :src="tag.image" height="30" width="30" />
									<div>{{ tag.name }}</div>
								</div>
							</div>
							<div class="pp_prod_add_row clearfix">
								<Producttype
									v-bind:product="product"
									v-if="(product.type !== 'unit' && product.type !== 'unitaskg') || product.spread"
								></Producttype>
								<!--
                  <div class="right addto_amount clearfix">
                      <a
                          class="right addto_amount_it active"
                          href="javascript:void(0);"
                      >יח׳</a>
                      <a class="right addto_amount_it" href="javascript:void(0);">ק״ג</a>
                  </div>
                -->
								<div class="right addto_btn_before ease" v-bind:class="{ hide_it: product.quantity }">
									<a href="javascript:void(0);" @click="incrementProduct([product, $event])">
										הוספה לעגלה
									</a>
								</div>
								<div
									class="right addto_btn addto_btn_after clearfix"
									v-bind:class="{ show_it: product.quantity }"
								>
									<input
										class="addto_cart_num"
										type="number"
										@change="updateCart([product, $event])"
										v-model="product.quantity"
									/>
									<div class="plus ease">
										<a href="javascript:void(0);" @click="incrementProduct([product, $event])">
											<plus />
										</a>
									</div>

									<Producttype
										v-bind:product="product"
										v-if="
											product.type === 'unit' ||
												(product.type === 'unitaskg' && !product.spread && this.$mq != 'mobile')
										"
									></Producttype>
									<div class="minus ease">
										<a href="javascript:void(0);" @click="decrementProduct([product, $event])">
											<minus />
										</a>
									</div>
								</div>
							</div>
							<div class="no_mobile pp_prod_favo_row clearfix">
								<div
									v-if="!this.$store.state.allowPermOrder"
									title="בקרוב יעלה שירות הזמנה קבועה. משלוח קבוע בזמן ובמועד שנוח לך."
									class="right pp_favo_bt ease soon-link hasTooltip"
								>
									<a href="javascript:void(0);">
										הוספה להזמנה קבועה
										<addbook />
									</a>
								</div>
								<div
									class="right pp_favo_bt ease"
									v-if="this.$store.state.allowPermOrder"
									:class="{ 'is--per': hasPermenanet }"
									style="display: block"
								>
									<a href="javascript:void(0);" @click="togglePermenent">
										{{ hasPermenanet ? "הסרה מהזמנה קבועה" : "הוספה להזמנה קבועה" }}
										<addbook />
									</a>
								</div>
								<div class="right pp_favo_bt add-heart ease" v-bind:class="{ active: isFav }">
									<a href="javascript:void(0);" @click="toggleFav([product, $event])"
										>שמירה במועדפים</a
									>
								</div>
							</div>
							<div class="no_mobile note_input" v-if="!product.no_comments">
								<input
									type="text"
									placeholder="הערה למוצר..."
									@input="disableUpdate"
									v-model="product.note"
									@blur="updateCart([product, $event])"
								/>
							</div>
							<div class="mobile_only m_pp_btns clearfix">
								<div class="right m_pp_btn_item ease add-heart" v-bind:class="{ active: isFav }">
									<a href="javascript:void(0);" @click="toggleFav([product, $event])">
										<span class="m_pp_btn_icon">
											<heart_s />
										</span>
										<span class="tx_normal" v-show="!isFav">הוספה למועדפים</span>
										<span class="tx_use" v-show="isFav">הסרה מהמועדפים</span>
									</a>
								</div>
								<div
									v-if="!this.$store.state.allowPermOrder"
									class="right m_pp_btn_item ease hasTooltip soon-link"
									title="בקרוב יעלה שירות הזמנה קבועה. משלוח קבוע בזמן ובמועד שנוח לך."
								>
									<a href="javascript:void(0);">
										<span class="m_pp_btn_icon">
											<addbook2 />
										</span>
										<span class="tx_normal">הוספה להזמנה קבועה</span>
									</a>
								</div>
								<div
									class="right m_pp_btn_item ease"
									v-if="this.$store.state.allowPermOrder"
									:class="{ 'is--per': hasPermenanet }"
									style=""
								>
									<a href="javascript:void(0);" @click="togglePermenent">
										<span class="m_pp_btn_icon">
											<addbook2 />
										</span>
										<span class="tx_normal" v-if="!hasPermenanet">הוספה להזמנה קבועה</span>
										<span class="tx_normal" v-if="hasPermenanet">הסרה מהזמנה קבועה</span>
									</a>
								</div>
								<div class="right m_pp_btn_item ease" v-if="!product.no_comments">
									<a
										href="javascript:void(0);"
										@click="$modal.show('product-note', { product: product })"
									>
										<span class="m_pp_btn_icon">
											<pen-magic />
										</span>
										<span class="tx_normal">הערה למוצר...</span>
										<span class="tx_use">עריכת הערה</span>
									</a>
								</div>
							</div>
						</div>
					</div>
					<div class="row clearfix">
						<div class="prod_details_wrap col-xs-12">
							<div class="no_mobile prod_details_tabs clearfix">
								<div class="right prod_details_tab text ease active" v-if="product.text">
									<a href="javascript:void(0);" onclick="toggleTab(this);" data-name="text"
										>כדאי לדעת</a
									>
								</div>
								<div
									class="right prod_details_tab ingredients ease"
									v-if="product.ingredients"
									v-bind:class="{ active: !product.text }"
								>
									<a href="javascript:void(0);" onclick="toggleTab(this);" data-name="ingredients"
										>רכיבים ופרטי יצרן</a
									>
								</div>
							</div>
							<div class="row prod_details_tab_tx text prod_details_open1" v-if="product.text">
								<div class="m_toggle active">
									<div class="mobile_only prod_details-tab">
										<a href="javascript:void(0);" onclick="mobileToggle(this);">
											כדאי לדעת
											<span class="check_col_plus"></span>
										</a>
									</div>
									<div class="m_toggleInner clearfix" style="display: block">
										<div class="right prod_details col-sm-7 col-xs-12">
											<div id="" class="prod_details_scroll">
												<!-- <div class="scrollbar">
                          <div class="track">
                            <div class="thumb">
                              <div class="end"></div>
                            </div>
                          </div>
                        </div> -->

												<div class="viewport">
													<div class="overview text" v-html="product.text"></div>
												</div>
											</div>
										</div>
										<div
											class="left prod_details_marks col-sm-4 col-xs-12"
											v-if="product.nutrition"
										>
											<div class="marks_row clearfix">
												<div class="right marks_col1 bold">סימון תזונתי</div>
												<div class="right marks_col2 bold">ל-100 גרם מוצר</div>
											</div>
											<div
												class="marks_row clearfix"
												v-for="nutrition in product.nutrition"
												:key="nutrition.name"
											>
												<div class="right marks_col1">{{ nutrition.name }}</div>
												<div class="right marks_col2">{{ nutrition.num }}</div>
											</div>
										</div>
									</div>
								</div>
                <div class="m_toggle active" v-if="product.ingredients">
                  <div class="mobile_only prod_details-tab">
                    <a href="javascript:void(0);" onclick="mobileToggle(this);">
                      רכיבים ופרטי יצרן
                      <span class="check_col_plus"></span>
                    </a>
                  </div>
                  <div class="m_toggleInner clearfix" style="display: block">
                    <div class="mobile_only right prod_details col-sm-7 col-xs-12">
                      <div id="" class="prod_details_scroll">
                        <div class="viewport">
                          <div class="overview text" v-html="product.ingredients"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
							</div>
							<div class="prod_details_tab_tx ingredients prod_details_open2"
								v-if="product.ingredients"
								v-html="product.ingredients"
								v-bind:style="[product.text ? { display: 'none' } : {}]"
							>
								<div class="m_toggle">
									<div class="mobile_only prod_details-tab">
										<a href="javascript:void(0);" onclick="mobileToggle(this);">
											כדאי לדעת
											<span class="check_col_plus"></span>
										</a>
									</div>
									<div class="m_toggleInner clearfix">
										<div class="right prod_details col-sm-7 col-xs-12">
											<div id="scrollbar1" class="prod_details_scroll">
												<div class="scrollbar">
													<div class="track">
														<div class="thumb">
															<div class="end"></div>
														</div>
													</div>
												</div>
												<div class="viewport">
													<div class="overview text" v-html="product.ingredients"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pp_prod_bottom">
					<h2 class="title25">חשבנו שיבוא לך גם</h2>
					<div class="pp_slide_wrap small-arrows">
						<div class="arrow_r ease">
							<a href="javascript:void(0);" @click.prevent="prev">
								<arrow_r />
							</a>
						</div>
						<div class="arrow_l ease">
							<a href="javascript:void(0);" @click.prevent="next">
								<arrow_l />
							</a>
						</div>
						<div class="no_mobile pp_slide more_pr_slide clearfix">
							<Slick
								ref="slick"
								:options="slickOptions"
								@init="handleInit"
								v-if="product.relatedProducts"
							>
								<Product
									v-bind:product="product"
									v-bind:index="index"
									v-for="(product, index) in product.relatedProducts"
									:key="product.id"
								></Product>
							</Slick>
						</div>

						<div class="mobile_only more_pr clearfix" v-if="product.relatedProducts">
							<Product
								v-bind:product="product"
								v-bind:index="index"
								v-for="(product, index) in product.relatedProducts.slice(0, 4)"
								:key="product.id"
							></Product>
						</div>
					</div>
					<div class="pp_note" v-html="disclaimer"></div>
				</div>
			</div>
		</div>
		<!-- <div class="bgblack"></div> -->
	</div>
</template>
<script>
	import Product from "../Product/Product";
	import Producttype from "../Product/ProductType";
	import Slick from "vue-slick";
	import { magnify } from "magnify";
	import PerfectScrollbar from "perfect-scrollbar";
  import {mapActions, mapGetters, mapState} from "vuex";
  import OrderUpdatedPopup from "./OrderUpdatedPopup";
	import CLOSE from "../../assets/img/close.svg";
	import arrow_l from "../../assets/img/arrow_l.svg";
	import arrow_r from "../../assets/img/arrow_r.svg";
	import plus from "../../assets/img/plus.svg";
	import minus from "../../assets/img/minus.svg";
	import addbook from "../../assets/img/addbook.svg";
	import addbook2 from "../../assets/img/addbook2.svg";
	import glass from "../../assets/img/glass.svg";
	import heart_s from "../../assets/img/heart-s.svg";
	import penMagic from "../../assets/img/pen-magic.svg";
	import snow from "../../assets/img/snow.svg";
  import new_svg from "../../assets/img/new.svg";

	export default {
		props: ["product", "index"],
		data() {
			return {
				currencySymbol: wpData.currencySumbol,
				disclaimer: wpData.globalOptions.disclaimer_popup,
				preventUpdate: true,
				slickThumbOptions: {
					slidesToShow: 1,
					rtl: true,
					arrows: true
				},
				slickOptions: {
					slidesToShow: 3,
					slidesToScroll: 3,
					rtl: true,
					arrows: false,
					responsive: [
						{
							breakpoint: 800,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								slidesPerRow: 1,
								rows: 2
							}
						}
					]
				},
        isAdmin: wpData.user.isAdmin,
			};
		},
		computed: {
			...mapGetters(["getSale", "getWeightText", "pricePer100", "pricePer100Text"]),
			hasPermenanet: function() {
				if (typeof this.$store.state.permOrder == "object") {
					let all_per_products = this.$store.state.permOrder.products;
					let find = all_per_products.find(p => p.id == this.product.id);
					if (typeof find !== "undefined") {
						return true;
					}
				}
				if (typeof this.$store.state.permOrder != "object") {
					let find = this.$store.state.permanentproducts.find(p => p.id == this.product.id);
					if (typeof find != "undefined") {
						return true;
					}
				}
				return false;
			},
			weightText: function() {
				let text = this.getWeightText(this.product);
				if (this.product.text_after_weight) {
					text = text + " " + this.product.text_after_weight;
				}
				return text;
			},
			sale: function() {
				return this.getSale(this.product.id);
			},
      isFav: function() {
        if (typeof this.$store.state.storedFavs !== "object") {
          return false;
        }
        return this.$store.state.storedFavs.some(p => p.id === this.product.id);
      },
			unitPriceText: function() {
				switch (this.product.type) {
					case "unit":
						if (this.product.case) {
							return "מארז";
						}
						return "יח׳";
						break;
					case "kg":
						return "ק״ג";
						break;
					case "both":
						return "ק״ג";
						break;
					case "unitaskg":
						return "ק״ג";
						break;
				}
			},
			pricePerW() {
				if (this.product.type == "both" || this.product.type == "kg" || this.product.type == "unitaskg") {
					let price = parseFloat(this.product.price) / 10;
					return price.toFixed(2);
				}
				if (parseFloat(this.product.weight) > 0) {
					let price = ((1 / parseFloat(this.product.weight)) * parseFloat(this.product.price)) / 10;
					return price.toFixed(2);
				}
				return false;
			},
			hasGallery: function() {
				if (Object.keys(this.product.gallery).length > 0) {
					return true;
				}
				return false;
			}
		},
		watch: {
			"product.selected": function(selected) {
				this.updateCart([this.product]);
			}
		},
		mounted() {
			window.topLocation = window.pageYOffset;
			//this.reInit();
			if (this.$route.name == "permenent") {
				let find_product = this.$store.state.added.find(p => p.id == this.product.id);
				if (typeof find_product != "undefined") {
					this.product.quantity = find_product.quantity;
					this.product.note = find_product.note;
				}
			}
			//console.log(this.$store.dispatch("getSale", this.product.id));
			const ps = new PerfectScrollbar(".viewport", {
				maxScrollbarLength: 60
			});
			this.$nextTick(() => {
				this.$store.dispatch("initToolTip");
				$(document).ready(function() {});
			});
			$(document).ready(function() {
				$(".pop_product .product_img_zoom img").magnify();
			});
			this.sendEvent();
		},
		updated() {
			if (this.preventUpdate) {
				this.$nextTick(function() {
					if (this.$refs.slick) {
						this.$refs.slick.create(this.slickOptions);
					}
					if (this.$refs.thumb) {
						this.$refs.thumb.create(this.slickThumbOptions);
					}
					if (window.innerWidth < 800) {
						var modal = document.getElementById("popupInPageSet");
						modal.scrollTop = 0;
					}
					$(".pop_product .product_img_zoom img").magnify();
					this.sendEvent();
					this.sendImmpressionsProducts(this.relatedProducts);
				});
			}
		},
		beforeUpdate() {
			if (this.preventUpdate) {
				if (this.$refs.slick) {
					this.$refs.slick.destroy();
				}
				if (this.$refs.thumb) {
					this.$refs.thumb.destroy();
				}
			}
		},
		methods: {
			sendEvent() {
				var productObj = {};
				var list = this.$route.name.capitalize();
				if (this.$route.name == "subcategory") {
					list = this.$route.name.capitalize();
				}
				if (this.$route.name == "category") {
					list = this.$route.name.capitalize();
				}
				var categories = this.$store.state.categories;
				let product_category = categories.find(cat => cat.id == this.product.categories[0]);
				productObj.id = this.product.id;
				productObj.name = this.product.name;
				productObj.price = this.product.price;
				productObj.category = product_category.name;
				productObj.position = this.product.index;
				productObj.list = list; /*this.createProductObj(this.product.relatedProducts);*/
				productObj.variant = "";

				sendProductClick(productObj, list);
				sendProductView(productObj);
			},
			next() {
				this.$refs.slick.next();
			},
			disableUpdate() {
				this.preventUpdate = false;
			},
			prev() {
				this.$refs.slick.prev();
			},
			thumbNext() {
				this.$refs.thumb.next();
			},
			thumbPrev() {
				this.$refs.thumb.prev();
			},
			reInit() {
				// Helpful if you have to deal with v-for to update dynamic lists
				this.$nextTick(() => {
					this.$refs.slick.reSlick();
					this.$refs.thumb.reSlick();
				});
			},
			handleInit(event, slick) {
				slick.init();
			},

			closePop() {
				this.$modal.hide("prod-modal");
				this.$store.dispatch("clearProductPop");
				this.$root.$emit("closeProductPop");
			},
      toggleFav([product, event]) {
        this.$ajax({
          method: "POST",
          url: ajaxUrl,
          params: {
            action: "addToFav",
            id: product.id
          }
        });

        // Add or remove from state
        if (this.$store.state.storedFavs.some(p => p.id === product.id)) {
          this.$store.state.storedFavs = this.$store.state.storedFavs.filter(p => p.id != product.id);
          sendRemoveFromFav(product);
        } else {
          this.$store.state.storedFavs.push(product);
          sendAddToFav(product);
        }
        localStorage.setItem("fav_products", this.$store.state.storedFavs);
      },
			togglePermenent() {
				let perOrder = this.$store.state.permOrder;
				if (typeof perOrder == "object") {
					let find = perOrder.products.find(product => product.id == this.product.id);
					if (typeof find == "undefined") {
						this.addToPermanent(this.product);
						let newProduct = Object.assign({}, this.product);
						if (newProduct.selected == "kg") {
							newProduct.quantity = 0.5;
						} else {
							newProduct.quantity = 1;
						}
						this.$store.state.permOrder.products.push(newProduct);
					} else {
						let indexOfProduct = perOrder.products.indexOf(find);
						this.$store.state.permOrder.products.splice(indexOfProduct, 1);
						this.$store.commit("removePermenant", indexOfProduct);
					}
					this.updatePermOrder();
				} else {
					if (this.hasPermenanet) {
						let find = this.$store.state.permanentproducts.find(p => p.id == this.product.id);
						let indexOfProduct = this.$store.state.permanentproducts.indexOf(find);
						//this.$store.state.permOrder.products.splice(indexOfProduct,1);
						this.$store.commit("removePermenant", indexOfProduct);
					} else {
						this.addToPermanent(this.product);
					}
				}
			},
			updatePermOrder() {
				var products_to_send = [];
				for (var i in this.$store.state.permOrder.products) {
					products_to_send.push({
						id: this.$store.state.permOrder.products[i].id,
						qu: this.$store.state.permOrder.products[i].quantity,
						note: this.$store.state.permOrder.products[i].note,
						type: this.$store.state.permOrder.products[i].selected,
						product_often: this.$store.state.permOrder.products[i].product_often,
						spread: this.$store.state.permOrder.products[i].spread
							? this.$store.state.permOrder.products[i].selected
							: ""
					});
				}
				this.$store.dispatch("updatePermanentOrder", JSON.stringify(products_to_send));
			},
			...mapActions(["updateCart", "incrementProduct", "addToPermanent", "decrementProduct", "openPopupProduct"])
		},
		components: {
			Product,
			Producttype,
			CLOSE,
			arrow_l,
			arrow_r,
			plus,
			minus,
			addbook,
			addbook2,
			heart_s,
			penMagic,
			glass,
			snow,
      new_svg,
			Slick
		}
	};
</script>
<style scoped>
	.pod_icon_wrap .pod_icon {
		margin-left: 5px;
		margin-bottom: 5px;
		display: flex;
		align-items: center;
		column-gap: 3px;
	}
	.pod_icon_wrap .pod_icon:last-child {
		margin-left: 0px;
		margin-bottom: 0;
	}
	.pod_icon_wrap .pod_icon svg {
		height: 15px;
	}
	.pod_icon_wrap .pod_icon.vegan {
		background-color: #df9fb2;
	}
	.pod_icon_wrap .pod_icon.frozen {
		background-color: #8ed5ea;
	}
  .pod_icon_wrap .pod_icon.israeli {
    background-color: #5A99E3;
    height: 39px;
    line-height: 13px;
  }
	#pop_product {
		display: block;
	}
	.nutrition-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 10px 15px;
		margin: 1em 0;
		padding: 10px 0;
		border: 1px solid #dbdbdb;
		border-width: 1px 0;
	}
  /*.pr_title_note.sale-subtitle {*/
  /*  margin: -5px 0 6px;*/
  /*}*/
  .new-product {
    position: absolute;
    top: 4px;
    left: 8px;
    width: 42px;
  }
  .new-product svg {
    fill: #fff;
  }

	@media (min-width: 768px) {
		.nutrition-tags {
			margin-left: -5em;
		}
	}
	.nutrition-tags > div {
		display: flex;
		align-items: center;
	}
	.nutrition-tags img {
		margin-left: 5px;
	}
	.nutrition-tags > div > div {
		font-size: 12px;
	}

	@media only screen and (max-width: 800px) {
		.pod_icon_wrap {
			flex-direction: row;
		}
		.pod_icon_wrap .pod_icon:last-child {
			margin-left: 0px;
			margin-bottom: 5px;
		}
    .new-product {
      position: static;
      margin: -10px 0 20px;
    }
	}
</style>
